import React from 'react';
import { ButtonType, ButtonColor } from '@lux/buttons';
import { Preset, Tag, Text } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { TncAndVoucherPolicy } from '../tnc-voucher-policy';
import { SubscribeButton } from './styles';
export const SingleUserContent = ({ onSubscribe }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { preset: Preset.M, tag: Tag.P },
            React.createElement(Translate, { message: "subscribeToNewsletters" })),
        React.createElement(SubscribeButton, { color: ButtonColor.dark, buttonType: ButtonType.primary, onClick: onSubscribe, fullWidth: true },
            React.createElement(Translate, { message: "signUpAndSave" })),
        React.createElement(TncAndVoucherPolicy, null)));
};
//# sourceMappingURL=component.js.map